import { render, staticRenderFns } from "./FishCounter.vue?vue&type=template&id=5ca5c77d&scoped=true"
import script from "./FishCounter.vue?vue&type=script&lang=ts"
export * from "./FishCounter.vue?vue&type=script&lang=ts"
import style0 from "./FishCounter.vue?vue&type=style&index=0&id=5ca5c77d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5c77d",
  null
  
)

export default component.exports